<template>
  <div
    class="border px-4 py-3 rounded flex"
    :class="{'border-ma-red-3 error': isErrorAlertType}"
    role="alert"
  >
    <div>
      <i
        class="fa-solid mr-2 text-base"
        :class="{'fa-circle-exclamation text-ma-red-3' : isErrorAlertType}"
      />
    </div>
    <slot />
  </div>
</template>

<script>
import { ALERT_TYPES } from '@/constants';

export default {
  props: {
    alertType: {
      type: String,
      required: true,
    },
  },
  computed: {
    isErrorAlertType() {
      return this.alertType === ALERT_TYPES.ERROR;
    },
  },
};
</script>

<style scoped>
.error {
  background: rgba(242, 134, 131, 0.18);
}
</style>
